import { BlurFilter, Container, Sprite, Text, TextStyle } from "pixi.js";

import { Group, Tween } from "tweedle.js";
import { globalScreen, languageGlobal } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// const headingTextStyle = new TextStyle({
//     fontFamily: "8-bit_quest_intro_1",
//     // fill: "#ffeeb3",
//     // fontWeight: "bold",
//     fontSize: 45,
//     // // stroke: {
//     // //     color: "#000000",
//     // //     width: 3,
//     // // },
//     // dropShadow:
//     // {
//     //     blur: 8,
//     //     color: "#000000",
//     //     distance: 7,
//     // },
//     // letterSpacing: 2

// });





// const VolatilityTextStyle = new TextStyle({
//     fontFamily: "8-bit_quest_intro_2",
//     // fill: "#f7e6c8",
//     fontSize: 35,
//     // align: "center",
//     // letterSpacing : 1.5,
//     // stroke: {
//     //     color: "#000000",
//     //     width: 3,
//     // },
//     // dropShadow:
//     // {
//     //     blur: 3,
//     //     color: "#320900",
//     //     distance: 5,
//     // },
//     // trim: true,
// });




export class IntroScene extends Container {
    // public loaderBar: Container = new Container();

    private allTextContainer: Container = new Container();


    private continueButtonContainer: Container = new Container();

    private tileContainer1 = new Container();
    private tileContainer2 = new Container();
    private tileContainer3 = new Container();
    private tileIndex: number = 0;
    private animationInterval: any;

    private tweenGroupForTiles: Group = new Group();
    private tweenGroupForScale: Group = new Group();

    private screenWidth: number = 0;
    private screenHeight: number = 0;

    constructor() {
        super();

        this.eventMode = 'static';
        this.interactive = true;




        console.log("languageGlobal", languageGlobal)


        // switch (languageGlobal) {
        //     case "en":
        //         descriptionTextStyle.fontFamily = "nokiafc22";
        //         break;

        //     default:
        //         descriptionTextStyle.fontFamily = "\"Comic Sans MS\", cursive, sans-serif";
        //         break;
        // }




    }

    private backgroundImage: Sprite | null = null;
    public async showInitLogo(screenWidth: number, screenHeight: number) {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.backgroundImage = Sprite.from('background');
        const blurFilter = new BlurFilter();
        blurFilter.strength = 10;
        this.backgroundImage.filters = [blurFilter];

        this.addChild(this.backgroundImage);

        this.addChild(this.allTextContainer);


        const logo: Sprite = Sprite.from('logoStatic');
        logo.scale = 0.6;
        logo.anchor = 0.5;
        logo.position.set(globalScreen / 2, 594);
        this.allTextContainer.addChild(logo);


        this.setupVolatilityText();

        /*------------------------------------- */

        this.tileContainer1.position.set(436, 1133);
        this.allTextContainer.addChild(this.tileContainer1);

        const tileImage1 = "image1";
        const headingTextVal1 = translationManager.game('intro_ticket_heading_1_uc');//"WILD LOOT";
        const descTextVal1 = translationManager.game('intro_ticket_desc_1');//"Winning symbols burst away and a random number of wilds fill the gaps on reels 2-4!";

        this.setupTile(this.tileContainer1, tileImage1, headingTextVal1, descTextVal1, 'textBase1');

        /*------------------------------------- */

        this.tileContainer2.position.set(globalScreen, 1033);
        this.allTextContainer.addChild(this.tileContainer2);

        const tileImage2 = "image2";
        const headingTextVal2 = translationManager.game('intro_ticket_heading_2_uc');//"MULTIPLIER MANIA";
        const descTextVal2 = translationManager.game('intro_ticket_desc_2');//"Multipliers up to 100x may appear on wilds, boosting wins and accumulating for epic payouts!";

        this.setupTile(this.tileContainer2, tileImage2, headingTextVal2, descTextVal2, 'textBase2');

        /*------------------------------------- */

        this.tileContainer3.position.set(1612, 1133);
        this.allTextContainer.addChild(this.tileContainer3);

        const tileImage3 = "image3";
        const headingTextVal3 = translationManager.game('intro_ticket_heading_3_uc');//"8-BIT BONUS";
        const descTextVal3 = translationManager.game('intro_ticket_desc_3');//"Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!Earn bigger multipliers in free spins that accumulate and persist throughout the bonus game!";

        this.setupTile(this.tileContainer3, tileImage3, headingTextVal3, descTextVal3, 'textBase3');

        /*------------------------------------- */

        this.setupContinueButton();

        let currentVal: number = .75;
        let targetVal: number = 1;
        new Tween({ x: currentVal }, this.tweenGroupForScale)
            .to({ x: targetVal }, 300)
            .onComplete(() => {
                this.tweenGroupForScale.removeAll();
            })
            .onUpdate((object) => {
                currentVal = object.x; // Update currentVal with the tweened value
                this.resize(this.screenWidth, this.screenHeight, currentVal);
                // this.tileContainer1.scale = currentVal;
                // this.tileContainer2.scale = currentVal;
                // this.tileContainer3.scale = currentVal;

                // logo.scale = currentVal;
                // this.lodo.scale = currentVal;
            })
            .start();



        // this.resize(this.screenWidth, this.screenHeight);

    }


    private setupTile(tileContainer1: Container, tileImageName: string, headingTextVal: string, descTextVal: string, textBaseTexture?: string): void {

        console.log(textBaseTexture);
        const tileBase1: Sprite = Sprite.from(`${textBaseTexture}`);
        tileBase1.anchor = 0.5;
        tileContainer1.addChild(tileBase1);

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            letterSpacing: letterSpacingHeading,
            lineHeight: lineHeightHeading
        } = getFontConfig(languageGlobal, "heading");


        // const fill = new FillGradient(0, 0, 0, 18 * 1 * 5);
        // const colors = ["#ffffff", "#e7ff95"].map((color) => Color.shared.setValue(color).toNumber());

        // colors.forEach((number, index) => {
        //     const ratio = index / colors.length;
        //     fill.addColorStop(ratio, number);
        // });

        const headingText = new Text({
            text: headingTextVal,
            style: {
                fontFamily: fontFamilyHeading,//"nokiafc22", //"\"Comic Sans MS\", cursive, sans-serif",
                fill: "#ffffff", //{ fill },
                fontWeight: fontWeightHeading,//"bold",
                fontSize: fontSizeHeading,//35,
                stroke: {
                    color: "#df5000",
                    width: 3,
                },
                dropShadow:
                {
                    blur: 5,
                    color: "#2b074f",
                    distance: 6,
                },
                letterSpacing: letterSpacingHeading,//1,
                wordWrap: true,
                wordWrapWidth: tileBase1.width - 140,
                align: "center",
                lineHeight: lineHeightHeading,//50
                breakWords: true,

            }
        });

        headingText.anchor.set(0.5, 0.5);
        headingText.position.set(0, -240);
        tileContainer1.addChild(headingText);



        let imageScale = 1;
        let imageY = -90;
        if (tileImageName == "image1") {
            imageScale = 0.9;
        }
        else if (tileImageName == "image2") {
            imageScale = .9;
        }
        else if (tileImageName == "image3") {
            imageScale = 1;
            imageY = -50;
        }

        const tileImage: Sprite = Sprite.from(tileImageName);
        tileImage.anchor = 0.5;
        tileImage.scale = imageScale;
        tileImage.position.set(0, imageY);
        tileContainer1.addChild(tileImage);




        const {
            fontFamily: fontFamilyDesc,
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,
            letterSpacing: letterSpacingDesc,
            lineHeight: lineHeightDesc
        } = getFontConfig(languageGlobal, "description");


        const descriptionTextStyle = new TextStyle({
            fontFamily: fontFamilyDesc,//"\"Comic Sans MS\", cursive, sans-serif", //Helvetica",//upheavtt", "nokiafc22"
            fill: "#ffebfb",
            fontWeight: fontWeightDesc,
            fontSize: fontSizeDesc,
            stroke: {
                color: "#df5000",
                width: 2
            },
            dropShadow:
            {
                blur: 5,
                color: "#4b0035",
                distance: 3,
            },
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: letterSpacingDesc,
            ...(lineHeightDesc != null && { lineHeight: lineHeightDesc }), // only include if not null or undefined
            breakWords: true,

        });

        const descriptionText = new Text({
            text: descTextVal,
            style: descriptionTextStyle
        });

        // descriptionText.style.wordWrap = true;
        descriptionText.style.wordWrapWidth = tileBase1.width - 150;
        // descriptionText.style.lineHeight = 500;


        descriptionText.anchor.set(0.5, 0.5);
        descriptionText.position.set(3, 90);
        tileContainer1.addChild(descriptionText);


    }

    public update() {

        this.tweenGroupForScale.update();
        this.tweenGroupForTiles.update();

    }



    private setupVolatilityText(): void {




        const volatilityContainer = new Container();


        // const volatilityBase: Sprite = Sprite.from('volatilityBase');
        // volatilityBase.anchor = 0.5;
        // volatilityContainer.addChild(volatilityBase);


        volatilityContainer.position.set(globalScreen / 2, 729);
        this.allTextContainer.addChild(volatilityContainer);

        // const textStyle = new TextStyle({
        //     fontFamily: "Verdana",
        //     fill: "#ffffff",
        //     fontWeight: "bold",
        //     fontSize: 37,
        //     letterSpacing : 1.5,
        //     stroke : {
        //         color: 0x000000,
        //         width: 3,
        //       },

        // });

        // const text = new Text({ text: 'Volatility', style: textStyle });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "volatility");


        const text = new Text({
            text: translationManager.game('intro_volatility_uc'),//'VOLATILITY',
            style: {
                fontFamily: fontFamilyVal,
                fill: "#ffffff",
                stroke: {
                    color: "#df5000",
                    width: 3,
                },
                dropShadow:
                {
                    blur: 5,
                    color: "#08000d",
                    distance: 6,
                },
                fontSize: fontSizeVal,
                fontWeight: fontWeightVal,
            }
        });



        text.anchor.set(0.5, 0.5);
        text.position.set(-95, 0);

        const textScale = Math.min(220 / text.width, 1);
        text.scale = textScale;

        volatilityContainer.addChild(text);

        // volatilityBase.position.set(20 + text.width / 2, -2);


        // Define the volatility value
        const volatilityVal = 3; // Example value

        // Adding 5 vol images in a line
        const volSpacing = 40; // Space between each vol
        const volStartX = -60 + text.width / 2; // Starting position to center vols

        for (let i = 0; i < 5; i++) {
            const volTexture = i < volatilityVal ? 'volatilityOn' : 'volatilityOff';
            const vol = Sprite.from(volTexture);
            vol.scale = 0.9;
            vol.anchor.set(0.5);
            vol.position.set(volStartX + i * volSpacing, 0); // Adjust Y position as needed
            volatilityContainer.addChildAt(vol, 0);
        }

    }

    private setupContinueButton(): void {


        this.continueButtonContainer = new Container();
        // this.continueButtonContainer.cursor = 'pointer';
        // this.continueButtonContainer.eventMode = 'static';
        // this.continueButtonContainer.interactive = true;

        // const continueButtonBase: Sprite = Sprite.from('volatilityBase');
        // continueButtonBase.anchor = 0.5;
        // continueButtonBase.position.set(0, 2);

        // // this.continueButtonContainer.pivot.set(this.continueButtonContainer.width / 2, this.continueButtonContainer.height / 2)
        // this.continueButtonContainer.addChild(continueButtonBase);

        // this.continueButtonContainer.position.set(1500, 2300);
        this.allTextContainer.addChild(this.continueButtonContainer);

        // const textStyle = new TextStyle({
        //     fontFamily: "Verdana",
        //     fill: "#ffffff",
        //     fontWeight: "bold",
        //     fontSize: 32,
        //     letterSpacing : 1.5,
        //     stroke : {
        //         color: 0x000000,
        //         width: 3,
        //       },

        // });

        // const text = new Text({ text: 'Click to Continue', style: textStyle });

        const {
            fontFamily: fontFamilyVal,
            fontWeight: fontWeightVal,
            fontSize: fontSizeVal,
        } = getFontConfig(languageGlobal, "continue");


        const text = new Text({
            text: translationManager.game('intro_continue_uc'),//'Click to Continue',
            style: {
                fontFamily: fontFamilyVal,
                fill: "#ffebfb",
                stroke: {
                    color: "#92007b",
                    width: 3,
                },
                dropShadow:
                {
                    blur: 5,
                    color: "#08000d",
                    distance: 6,
                },
                fontWeight: fontWeightVal,
                fontSize: fontSizeVal,
            }
        });


        text.anchor = 0.5;
        text.scale = Math.min(550 / text.width, 1);

        // text.position.set(continueButtonBase.width / 2, continueButtonBase.height / 2);

        this.continueButtonContainer.addChild(text);


        // this.continueButtonContainer.on('pointerover', () => {
        //     this.continueButtonContainer.tint = "#ffaa00";
        // });

        // this.continueButtonContainer.on('pointerout', () => {
        //     this.continueButtonContainer.tint = "#ffffff";
        // });

    }

    public resize(screenWidth: number, screenHeight: number, zoomFactor?: number): void {

        // console.log(`resize screenWidth${screenWidth} screenHeight ${screenHeight}`);

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        const isLandscape = screenWidth > screenHeight;

        let portraitscale;
        if (!isLandscape) {
            this.startTileAnimation();
            portraitscale = 1.75;

            this.continueButtonContainer.scale = 1;
            this.continueButtonContainer.position.set(globalScreen / 2, 1504);

        } else {
            this.landscapeTilePositions()
            portraitscale = 1;

            this.continueButtonContainer.scale = 1.2;
            this.continueButtonContainer.position.set(globalScreen / 2, 1474);

        }


        const scale = portraitscale * (zoomFactor ? zoomFactor : 1) * Math.min(screenWidth / (isLandscape ? 1920 : 1080), screenHeight / (isLandscape ? 1080 : 1920));
        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / globalScreen, screenHeight / globalScreen);

        this.allTextContainer.scale.set(scale, scale);
        const xPos = (globalScreen * scale - this.screenWidth) / 2;
        const yPos = (globalScreen * scale - this.screenHeight) / 2;
        this.allTextContainer.x = -xPos;
        this.allTextContainer.y = -yPos;

        bgScale = Math.max(scale, BG_SCALE_FACTOR);
        this.backgroundImage.scale.set(bgScale, bgScale)
        const bgXPos = (globalScreen * bgScale - screenWidth) / 2;
        const bgYPos = (globalScreen * bgScale - screenHeight) / 2;
        this.backgroundImage.position.set(-bgXPos, -bgYPos);

    }

    public endTileAnimation(): void {
        clearInterval(this.animationInterval);
    }

    private landscapeTilePositions(): void {

        // this.tileIndex = 0;
        clearInterval(this.animationInterval);

        // Cancel any active tweens (assuming Tween.js has a way to cancel)
        this.tweenGroupForTiles.removeAll();

        this.tileContainer1.position.set(436, 1133);
        this.tileContainer2.position.set(globalScreen / 2, 1083); // Place off-screen to the right
        this.tileContainer3.position.set(1612, 1133); // Place off-screen to the right
    }

    private startTileAnimation(): void {

        this.resetTilePositions();
        clearInterval(this.animationInterval);

        this.animationInterval = setInterval(() => {
            this.cycleTiles();
        }, 3000);
    }

    private resetTilePositions(): void {
        this.tileContainer1.position.set(globalScreen / 2, 1104);
        this.tileContainer2.position.set(globalScreen, 1104); // Place off-screen to the right
        this.tileContainer3.position.set(globalScreen, 1104); // Place off-screen to the right
        this.tileIndex = 0;
        clearInterval(this.animationInterval);
    }

    private cycleTiles(): void {
        const currentTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][this.tileIndex];
        const nextTile = [this.tileContainer1, this.tileContainer2, this.tileContainer3][(this.tileIndex + 1) % 3];

        new Tween(currentTile.position, this.tweenGroupForTiles)
            .to({ x: 0 }, 500)
            .start();

        new Tween(nextTile.position, this.tweenGroupForTiles)
            .to({ x: globalScreen / 2 }, 500)
            .onComplete(() => {
                // Move currentTile to the far right after it exits the screen
                currentTile.position.set(globalScreen, 1104);
            })
            .start();

        this.tileIndex = (this.tileIndex + 1) % 3;
    }

}
